import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { fetcherGetDownload, NOTIFY_REPORT_GENERATED } from "../utils";
import { getToken } from "../utils/auth";
import fileDownload from "js-file-download";
import { processResponse } from "../utils/error";

export const useDownloadDocuments = (
    onSuccessTrigger?: () => void
): [
        (vals: string[]) => void,
        (vals: string[]) => void,
        Function,
        boolean
    ] => {
    const auth0 = useAuth0();

    const [isLoading, setLoading] = useState(false);
    const [urls, setUrls] = useState<string[]>([]);
    const [filenames, setFilenames] = useState<string[]>([]);

    const triggerDownload = () => {
        if (!isLoading) setLoading(true);
    };

    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            const token = await getToken(auth0);

            for (let i = 0; i < urls.length; i++) {
                const [result, error] = await fetcherGetDownload(urls[i], token);

                processResponse(error, NOTIFY_REPORT_GENERATED);

                if (result && mounted) {
                    const blob = await result.blob();
                    fileDownload(blob, filenames[i] || `file_${i}`);
                }
            }

            if (onSuccessTrigger) onSuccessTrigger();
            setLoading(false);
        };

        if (isLoading && urls.length > 0 && filenames.length > 0) fetchData();

        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, urls, filenames]);

    return [setUrls, setFilenames, triggerDownload, isLoading];
};
